import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicRouteStrategy } from '@ionic/angular';

import { environment } from '@environments/environment';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { effects, metaReducers, reducers } from '@store/app.state';
import { GetIntegrationsModule } from '@store/configurator/getIntegrations/module';
import { GetPartnershipModule } from '@store/configurator/getPartnership/module';
import { GetRenewalActionsModule } from '@store/configurator/getRenewalActions/module';
import { PostRenewalInformationModule } from '@store/configurator/postRenewalInformation/module';
import { ApplicationUtilitiesStoreModule } from '@store/swagger/applicationUtilities';
import { AuthenticationsStoreModule } from '@store/swagger/authentications';
import { CatalogStoreModule } from '@store/swagger/catalog';
import { PolicyStoreModule } from '@store/swagger/policy';
import { ProjectStoreModule } from '@store/swagger/project';

// Avoid app module full of declarations

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    HttpClientModule,
    StoreModule.forRoot(reducers, { metaReducers }),
    EffectsModule.forRoot(effects),
    StoreDevtoolsModule.instrument({
      maxAge: 25, // Retains last 25 states
      logOnly: environment.production, // Restrict extension to log-only mode
    }),
    ApplicationUtilitiesStoreModule,
    AuthenticationsStoreModule,
    CatalogStoreModule,
    PolicyStoreModule,
    ProjectStoreModule,
    GetIntegrationsModule,
    GetPartnershipModule,
    GetRenewalActionsModule,
    PostRenewalInformationModule,
  ],
  declarations: [],
  providers: [{ provide: RouteReuseStrategy, useClass: IonicRouteStrategy }],
})
export class GlobalModule {
  static forRoot(): ModuleWithProviders<GlobalModule> {
    return {
      ngModule: GlobalModule,
    };
  }
}
